import React, { Component } from "react";
import { connect } from "react-redux";
import { sort } from "../actions/filesActions";
import TableList from "./TableList";
import CubesList from "./CubesList";
import DisplayOptionsSection from "./DisplayOptionsSection";
import { Container } from "reactstrap";
import HeaderImage from "../HeaderImage";

class ListView extends Component {
  state = {
    showTable: false,
    sortMode: "descending"
  };
  toggleSortModeHeandler = sortMode => {
    if (this.state.sortMode !== sortMode) {
      this.setState({ sortMode: sortMode });
      this.props.sort(
        this.props.viewData.displayOptions.listName,
        sortMode === "descending"
      );
    }
  };
  toggleSortByHeandler = sortMode => {
    // this.setState({ sortMode: sortMode });
    // this.props.sort(
    //   this.props.viewData.displayOptions.listName,
    //   sortMode === "descending"
    // );
  };
  toggleDispayModeHeandler = show => {
    this.setState({ showTable: show });
  };
  render() {
    let allItems = null;
    if (this.state.showTable) {
      allItems = (
        <TableList
          list={this.props.data}
          tableSettings={this.props.viewData.tableSettings}
        />
      );
    } else {
      allItems = (
        <CubesList
          list={this.props.data}
          cubesSettings={this.props.viewData.cubesSettings}
        />
      );
    }
    return (
      <Container className="px-0">
        <HeaderImage
          viewName={this.props.viewData.displayOptions.viewName}
          button={this.props.viewData.displayOptions.buttonComponent}
        />
        <DisplayOptionsSection
          sortBy={this.state.sortBy}
          sortMode={this.state.sortMode}
          showTable={this.state.showTable}
          displayOptions={this.props.viewData.displayOptions}
          dispayModeClick={show => this.toggleDispayModeHeandler(show)}
          sortModeClick={sortMode => this.toggleSortModeHeandler(sortMode)}
          sortByClick={sortBy => this.toggleSortByHeandler(sortBy)}
        />
        <br />
        <br />
        {allItems}
      </Container>
    );
  }
}

// const mapStateToProps = state => {
//   return {
//     data: state.files.allSpecifications
//   };
// };

const mapDispatchToProps = dispatch => {
  return {
    sort: (listName, descending) => dispatch(sort(listName, descending))
  };
};

export default connect(
  null,
  mapDispatchToProps
)(ListView);
